import { SearchFilterV4 } from "@/types/SearchFilter";
import { Button } from "@components/ui/button";
import { ButtonGroup } from "@components/ui/button-group";
import { SearchIcon, XIcon } from "lucide-react";
import { Trans } from "@lingui/react/macro";
import { Dispatch, SetStateAction } from "react";

export default function FreeText({
  setIsFreeTextOpen,
  onChange,
  value,
}: {
  onChange: (value: SearchFilterV4, clear?: boolean) => void;
  setIsFreeTextOpen: Dispatch<SetStateAction<boolean>>;
  value: SearchFilterV4["freetext"];
}) {
  return (
    <ButtonGroup>
      <Button
        size="xs"
        render={<div />}
        variant="outline"
        className="pointer-events-none"
      >
        <SearchIcon />
        <Trans>Omnämnande</Trans>
      </Button>
      <Button
        size="xs"
        render={<div />}
        variant="outline-muted"
        className="pointer-events-none"
      >
        <Trans>innehåller</Trans>
      </Button>
      <Button
        size="xs"
        type="button"
        variant="outline"
        onClick={() => {
          setIsFreeTextOpen(true);
        }}
      >
        <q>{value}</q>
      </Button>
      <Button
        size="icon-xs"
        variant="outline"
        type="button"
        onClick={() => {
          onChange({
            freetext: undefined,
          });
        }}
      >
        <XIcon />
        <span className="sr-only">
          <Trans>Ta bort filter</Trans>
        </span>
      </Button>
    </ButtonGroup>
  );
}
